export interface TranslationKey {
  translationKey: string;
  emailStatus: codesValidtion;
}
interface mapperObj {
  [key: string]: TranslationKey;
}
export enum codesValidtion {
  formBlocking = "formBlocking",
  valid = "valid",
  invalid = "invalid",
  blank = "blank"
}
const blockingCodes: mapperObj = {
  "04": {
    translationKey: "customer.data.fields.email.errors.EmptyEmail",
    emailStatus: codesValidtion.formBlocking
  },
  "93": {
    translationKey: "customer.data.fields.email.errors.blacklisted",
    emailStatus: codesValidtion.formBlocking
  },
  "94": {
    translationKey: "customer.data.fields.email.errors.UnauthorizedOrInsult",
    emailStatus: codesValidtion.formBlocking
  },
  "91": {
    translationKey: "customer.data.fields.email.errors.SyntaxError",
    emailStatus: codesValidtion.formBlocking
  },
  "95": {
    translationKey: "customer.data.fields.email.errors.Disposable",
    emailStatus: codesValidtion.formBlocking
  }
};
const valid: mapperObj = {
  "00": {
    translationKey: "customer.data.fields.email.valid",
    emailStatus: codesValidtion.valid
  },
  "03": {
    translationKey: "customer.data.fields.email.valid",
    emailStatus: codesValidtion.valid
  }
};
const invalid: mapperObj = {
  "01": {
    translationKey:
      "customer.data.fields.email.errors.CorrectEmail.CouldNotBeChecked",
    emailStatus: codesValidtion.invalid
  },
  "02": {
    translationKey: "customer.data.fields.email.validFormat.invalidEmail",
    emailStatus: codesValidtion.invalid
  },
  "92": {
    translationKey: "customer.data.fields.email.errors.UnknownDomain",
    emailStatus: codesValidtion.invalid
  }
};
const blank: mapperObj = {
  "99": {
    translationKey: "customer.data.fields.email.errors.ServiceNotAvailable",
    emailStatus: codesValidtion.blank
  }
};
const russianEmail: mapperObj = {
  ru: {
    translationKey: "customer.data.fields.email.valid.ru",
    emailStatus: codesValidtion.valid
  }
};

function chekForBasicFormat(email: string) {
  const emailRegex = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@/;
  return emailRegex.test(email);
}
export function getTransaltion(idErorr: string, email: string) {
  // if (idErorr === "91") {
  //   if (!chekForBasicFormat(email)) {
  //     const result: TranslationKey = {
  //       translationKey: "customer.data.fields.email.errors.invalid.format",
  //       emailStatus: codesValidtion.formBlocking
  //     };
  //     return result;
  //   }
  // }
  if (email) {
    if (checkForRussianEmail(email)) {
      const result: TranslationKey = {
        translationKey: russianEmail.ru.translationKey,
        emailStatus: russianEmail.ru.emailStatus
      };
      return result;
    }
  }
  const allCodes = {
    ...blockingCodes,
    ...valid,
    ...invalid,
    ...blank,
    ...russianEmail
  };
  if (Object.keys(allCodes).includes(idErorr)) {
    const codeObj = Object.entries(allCodes).find(item => item[0] === idErorr);
    if (codeObj) {
      const result: TranslationKey = {
        translationKey: codeObj[1].translationKey,
        emailStatus: codeObj[1].emailStatus
      };
      return result;
    }
  }
}

function checkForRussianEmail(email: string): boolean {
  const regex = /\.ru$/i;
  return regex.test(email);
}
